import { Component, Input, OnInit, forwardRef, Inject } from '@angular/core';
import { NgbActiveModal }          from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }       from '@ngx-translate/core';

import { ApiService }             from '../api/api.service';
import { CustomerFactoryService } from '../customers/customer-factory.service';
import { CustomerModel }          from '../customers/models/customer';
import { InvoiceModel }           from './models/invoice';
import { Table }                  from '../table/types/table';
import { TableColumn }            from '../table/types/table-column';
import { TableQueryParameters }   from '../table/types/table-query-parameters';
import { TableService }           from '../table/table.service';

@Component({
  selector: 'wor-invoices-for-payment',
  template: require('./invoices.for-payment.component.html')
})
export class InvoicesForPaymentComponent implements OnInit {
  @Input() customer: CustomerModel;
  @Input() invoices: Array<InvoiceModel>;
  @Input() settings: any;

  areAllSelected = false;
  columns: Array<TableColumn>;
  selectedItems: Array<InvoiceModel> = [];
  tableCacheKey = 'branchCustomerInvoices';
  tableSettings: Table;

  constructor (
    public activeModal: NgbActiveModal,
    @Inject(forwardRef(() => ApiService)) private apiService: ApiService,
    @Inject(forwardRef(() => CustomerFactoryService))
    private customerFactoryService: CustomerFactoryService,
    @Inject(forwardRef(() => TableService)) private tableService: TableService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    if (this.settings?.tableCacheKey) {
      this.tableCacheKey = this.settings.tableCacheKey;
    }

    this.customerFactoryService.setCustomer(this.customer);

    this.columns = [
      { classes: 'text-left', field: 'invoice_number', header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.REFERENCE') } },
      { classes: 'text-left', field: 'post_date', header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.POST_DATE') }, pipe: 'globalDate' },
      { classes: 'text-right', field: 'total', header: { classes: 'text-right', text: this.translateService.instant('JS_SPACE.COLUMNS.AMOUNT') }, pipe: 'globalCurrency' },
      { classes: 'text-right', field: 'balance_due', header: { classes: 'text-right', text: this.translateService.instant('JS_SPACE.COLUMNS.BALANCE') }, pipe: 'globalCurrency' }
    ];

    if (this.customerFactoryService.isBranchCustomer(this.customer)) {
      this.columns.splice(1, 0, {
        field: 'store_name',
        header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.STORE') }
      });
    }

    this.tableSettings = {
      cache: { enabled: true, key: this.tableCacheKey },
      columns: this.columns,
      empty: { text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND') },
      pagination: { enabled: false },
      rows: { select: { enabled: true, multi: true } },
      sorting: this.tableService.setSortingFromCache(this.tableCacheKey, { direction: 'desc', field: 'post_date' }),
      static: true
    };
  }

  handleInvoiceSelection(): void {
    this.selectedItems = this.invoices.filter(invoice => invoice.selected);
    this.areAllSelected = this.invoices.length === this.selectedItems.length;
  }

  toggleAll(): void {
    this.invoices.forEach(invoice => {
      invoice.selected = !this.areAllSelected;
    });
    this.areAllSelected = !this.areAllSelected;
    this.selectedItems = this.areAllSelected ? this.invoices : [];
  }

  getInvoices(params: TableQueryParameters): void {
    this.apiService.get('/customers/invoice_list', [
      this.customer.id, 0, '*', 'P', 'I', params.field, params.direction
    ]).then((invoices: Array<InvoiceModel>) => {
      this.invoices = invoices;
    });
  }
}
